import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import { Link } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  container: {
    backgroundColor: '#eaebeb',
    paddingTop: '10px',
    paddingBottom: '10px',
    marginTop: '2em',
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
  saicImg: {
    height: 'auto',
    width: '20%',
  },
  footerLink: {
    textDecoration: 'none',
    fontSize: '0.6rem',
    textTransform: 'uppercase',
    fontFamily: '"Franklin Gothic Medium", "Arial Narrow", sans-serif',
    display: 'block',
    lineHeight: '2',
    color: '#595b63',
  },
  footerLinkHeader: {
    textDecoration: 'none',
    textTransform: 'uppercase',
    fontFamily: '"Franklin Gothic Medium", Arial, sans-serif',
    color: '#006bb6',
  },
  footerLinkBottom: {
    textDecoration: 'none',
    fontSize: '0.6rem',
    textTransform: 'uppercase',
    fontFamily: '"Franklin Gothic Medium", Arial, sans-serif',
    lineHeight: '2',
    paddingTop: '10px',
    paddingLeft: '10px',
    paddingRight: '10px',
    color: '#595b63',
  },
}));

const Footer = () => {
  const classes = useStyles();
  return (
    <div className={classes.container}>
      <Container maxWidth="xl">
        <div className={classes.root}>
          <Grid container spacing={3} alignContent="center">
            <Grid item xs>
              <Container>
                <div style={{ textAlign: 'right' }}>
                  <img src="/SAIC.svg" className={classes.saicImg} alt="SAIC" />
                </div>
              </Container>
            </Grid>
            <Grid item xs>
              <Typography
                variant="caption"
                className={classes.footerLinkHeader}
              >
                QUICK LINKS
                <Link
                  href="https://www.saic.com/contact-us"
                  className={classes.footerLink}
                  color="textSecondary"
                >
                  + CONTACT US
                </Link>
                <Link
                  href="https://www.saic.com/employee-tools"
                  className={classes.footerLink}
                  color="textSecondary"
                >
                  + EMPLOYEE TOOLS
                </Link>
                <Link
                  href="https://www.saic.com/suppliers-and-small-business"
                  className={classes.footerLink}
                  color="textSecondary"
                >
                  + SUPPLIERS AND SMALL BUSINESS
                </Link>
              </Typography>
            </Grid>
            <Grid item xs>
              <Typography
                variant="overline"
                display="block"
                className={classes.footerLinkHeader}
                align="left"
              >
                CONNECT: <br />
              </Typography>
              <a
                href="https://twitter.com/SAICinc"
                target="_blank"
                rel="noopener noreferrer"
                className="svgPadding"
              >
                <img src="/Twitter.svg" alt="Twitter" />
              </a>

              <a
                href="https://www.facebook.com/SAICinc"
                target="_blank"
                rel="noopener noreferrer"
                className="svgPadding"
              >
                <img src="/Facebook.svg" alt="FaceBook" />
              </a>

              <a
                href="https://www.linkedin.com/company/saicinc/"
                target="_blank"
                rel="noopener noreferrer"
                className="svgPadding"
              >
                <img src="/LinkedIn.svg" alt="LinkedIn" />
              </a>

              <a
                href="https://www.instagram.com/saicinc"
                target="_blank"
                rel="noopener noreferrer"
                className="svgPadding"
              >
                <img src="/Instagram.svg" alt="Instagram" />
              </a>

              <a
                href="https://www.youtube.com/user/ScienceApplications"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src="/YouTube.svg" alt="YouTube" />
              </a>
            </Grid>
          </Grid>
          <Grid container spacing={3}>
            <Grid item xs />
            <Grid item xs={6}>
              <Typography align="center">
                <Link
                  href="https://www.saic.com/"
                  className={classes.footerLinkBottom}
                  color="textSecondary"
                >
                  © 2019 SAIC
                </Link>
                <span className={classes.footerLinkBottom}>/</span>
                <Link
                  href="https://www.saic.com/privacy-statement"
                  className={classes.footerLinkBottom}
                  color="textSecondary"
                >
                  PRIVACY STATEMENT
                </Link>
                <span className={classes.footerLinkBottom}>/</span>
                <Link
                  href="https://www.saic.com/terms-of-use"
                  className={classes.footerLinkBottom}
                  color="textSecondary"
                >
                  TERMS OF USE
                </Link>
                <span className={classes.footerLinkBottom}>/</span>
                <Link
                  href="https://www.saic.com/copyright"
                  className={classes.footerLinkBottom}
                  color="textSecondary"
                >
                  COPYRIGHT
                </Link>
                <span className={classes.footerLinkBottom}>/</span>
                <Link
                  href="https://investors.saic.com/corporate-governance"
                  className={classes.footerLinkBottom}
                  color="textSecondary"
                >
                  CORPORATE GOVERNANCE
                </Link>
              </Typography>
            </Grid>
            <Grid item xs />
          </Grid>
        </div>
      </Container>
    </div>
  );
};

export default Footer;
